// checkout/steps/loginOrRegisterListeners.ts

import { submitFormAndUpdateStep } from '../utils/submitForm';
import { checkoutData } from '../init';
import { initTurnstile, withTurnstile } from '../../utils/turnstile';
import {
	isValidInput,
	restrictToRange,
	validateFullDob,
} from '../../authenticate/loginOrRegisterListeners';

/**
 * Attaches all login and registration form event listeners for checkout only,
 * including accessibility and keyboard behaviour.
 */
export function addLoginOrRegisterListeners(): void {
	const registrationForm = document.getElementById('registrationForm') as HTMLFormElement | null;
	const loginForm = document.getElementById('loginForm') as HTMLFormElement | null;

	if (registrationForm) {
		const registerSubmitBtn = document.getElementById(
			'auth__submit-register',
		) as HTMLButtonElement | null;

		if (registerSubmitBtn) {
			const registerInput = document.querySelector(
				'input[name="newCustomerUsername"]',
			) as HTMLInputElement | null;
			const emailInput = document.getElementById('emailHandle') as HTMLInputElement | null;

			if (emailInput && registerInput) {
				registerSubmitBtn.addEventListener('click', () => {
					emailInput.value = registerInput.value;
				});
			}
		}

		const dobDay = document.getElementById('registerForm-dob.day') as HTMLInputElement | null;
		const dobMonth = document.getElementById(
			'registerForm-dob.month',
		) as HTMLInputElement | null;
		const dobYear = document.getElementById('registerForm-dob.year') as HTMLInputElement | null;

		const errDay = document.getElementById('registerForm-dob-day-error') as HTMLElement | null;
		const errMonth = document.getElementById(
			'registerForm-dob-month-error',
		) as HTMLElement | null;
		const errYear = document.getElementById(
			'registerForm-dob-year-error',
		) as HTMLElement | null;
		const errOverall = document.getElementById('registerForm-dob-error') as HTMLElement | null;

		if (dobDay && dobMonth && dobYear) {
			restrictToRange(dobDay, 1, 31, 2, errDay, 'Please enter a valid day.');
			restrictToRange(dobMonth, 1, 12, 2, errMonth, 'Please enter a valid month');
			restrictToRange(dobYear, 1900, 2099, 4, errYear, 'Please enter a valid year');

			dobDay.addEventListener('input', () => {
				if (dobDay.value.length === 2 && isValidInput(dobDay, 1, 31)) dobMonth.focus();
				validateFullDob(dobDay, dobMonth, dobYear, errOverall);
			});
			dobMonth.addEventListener('input', () => {
				if (dobMonth.value.length === 2 && isValidInput(dobMonth, 1, 12)) dobYear.focus();
				validateFullDob(dobDay, dobMonth, dobYear, errOverall);
			});
			[dobDay, dobMonth, dobYear].forEach((el) => {
				el.addEventListener('blur', () =>
					validateFullDob(dobDay, dobMonth, dobYear, errOverall),
				);
			});

			registrationForm.addEventListener(
				'submit',
				withTurnstile(registrationForm, 'register', async () => {
					const action = checkoutData.register?.action;
					validateFullDob(dobDay, dobMonth, dobYear, errOverall);
					await submitFormAndUpdateStep(registrationForm, action);
				}),
			);
		}
	}

	/**
	 * Handles login form submission and keyboard behaviour.
	 */
	if (loginForm) {
		// Submit login form
		loginForm.addEventListener(
			'submit',
			withTurnstile(loginForm, 'login', async () => {
				const action = checkoutData.login?.action;
				await submitFormAndUpdateStep(loginForm, action);
			}),
		);
	}

	initTurnstile();
}
